import { $ } from "bun";
import { atomWithCache } from "jotai-cache";
import { atomFamily } from "jotai/utils";

interface AuthorProviderInfo {
	id: string;
	provider: string;
}

function parseAuthorId(authorId: string): AuthorProviderInfo | undefined {
	const [provider, id] = authorId?.split("|") ?? [];
	if (!provider || !id) {
		return;
	}

	return { id, provider };
}

export const $authors = atomFamily((authorId: string) => {
	const $authorAtom = atomWithCache(async () => {
		const authorInfo = parseAuthorId(authorId);
		if (!authorInfo) {
			return null;
		}

		const { provider, id } = authorInfo;
		switch (provider) {
			case "github": {
				const profile = await (await fetch(`https://api.github.com/user/${id}`)).json();
				const displayName = profile?.name;
				const githubUsername = profile?.login;
				const bio = profile?.bio;
				const profileImageFallback =
					typeof displayName === "string"
						? displayName
								.split(/\s/)
								.map((n) => n[0])
								.join("")
								.toUpperCase()
						: "?";

				return {
					provider,
					id,
					profileImageUrl: profile?.avatar_url,
					displayName,
					profileImageFallback,
					githubUsername,
					bio,
				};
			}
		}

		return null;
	});
	$authorAtom.debugLabel = `authorAtom(${authorId})`;
	return $authorAtom;
});
